import React from 'react';
import { Close } from '@mui/icons-material';
import { Paper, Stack, Typography } from '@mui/material';

import { useIsMobileViewport } from '@/hooks/useIsMobileViewport';

interface NotificationToastProps {
  title: string;
  message: string;
  actions: React.ReactNode;
  dismissToast: () => void;
}

const NotificationToast: React.FC<NotificationToastProps> = ({
  title,
  message,
  actions,
  dismissToast
}) => {
  const isMobileViewport = useIsMobileViewport();

  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: '8px',
        padding: '16px',
        minWidth: isMobileViewport ? '100%' : '280px',
        maxWidth: '620px'
      }}
    >
      <Stack
        bgcolor="var(--palette-semantic-background-base)"
        direction="column"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" gap={0} alignItems="center">
            <Typography
              fontSize="16px"
              color="var(--palette-semantic-text-primary)"
              fontWeight={500}
            >
              {title}
            </Typography>
          </Stack>
          <Close
            onClick={dismissToast}
            sx={{ cursor: 'pointer' }}
            htmlColor="var(--palette-semantic-icon-quaternary)"
          />
        </Stack>
        <Stack>
          <Typography
            color="var(--palette-semantic-text-secondary)"
            fontSize="12px"
            fontWeight={400}
            marginTop="8px"
            sx={{
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              lineHeight: '1.4'
            }}
          >
            {message}
          </Typography>
        </Stack>
        {actions && <Stack mt={1}>{actions}</Stack>}
      </Stack>
    </Paper>
  );
};

export default NotificationToast;
